export enum MatomoModeEnum {
  TAG_MANAGER = 'cloud_hosted',
  BASIC = 'on_premise'
}